import React, { ReactNode } from "react"
import {KakaoPlusFriendButton} from "./index";

interface Props {
  left?: ReactNode
  right?: ReactNode
}

function Header({ left, right }: Props) {
  return (
    <article className="topB">
      {left}
      <ul className="controlB">
        {right}
        <KakaoPlusFriendButton />
      </ul>
    </article>
  )
}

export default Header
